import type { DoorListItem } from '@/opendoors-api/client'
import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useQuotationsStore = defineStore('quotations', () => {
  const selectedDoorRows = useLocalStorage<DoorListItem[]>('selectedDoorRows', [])
  // TODO: Remove this once the details endpoint contain db stored quote number. It then will be reading from the details endpoint
  const currentQuoteNumber = useLocalStorage<string>('currentQuoteNumber', '')

  // Column visibility state for import mapper - temporary persistence for child route navigation
  const columnVisibility = useLocalStorage<Record<string, boolean>>('columnVisibility', {})

  // bulk update door list items
  const setSelectedDoorRows = (rows: DoorListItem[]) => {
    selectedDoorRows.value = rows
  }

  // set current quote number from table row data
  const setCurrentQuoteNumber = (quoteNumber: string) => {
    currentQuoteNumber.value = quoteNumber
  }

  // set column visibility state
  const setColumnVisibility = (visibility: Record<string, boolean>) => {
    columnVisibility.value = visibility
  }

  return {
    selectedDoorRows,
    setSelectedDoorRows,
    currentQuoteNumber,
    setCurrentQuoteNumber,
    columnVisibility,
    setColumnVisibility
  }
})
